import { register, getPrefix } from '../../../Utils'

const MobileNavigation = el => {
  const prefix = getPrefix(el)
  const submenus = el.querySelectorAll(`.${prefix}has--children`)
  const togglers = el.querySelectorAll(`.${prefix}submenu-toggler`)

  const toggleSubmenu = (submenu, toggler, action) => {
    if (toggler.classList.contains(`${prefix}action--open`)) {
      togglers.forEach(toggle => {
        toggle.classList.add(`${prefix}action--open`)
      })
      submenus.forEach(submenu => {
        submenu.classList.remove(`${prefix}is--expanded`)
      })
      toggler.classList.remove(`${prefix}action--open`)
      submenu.classList.add(`${prefix}is--expanded`)
    } else {
      submenu.classList.remove(`${prefix}is--expanded`)
      toggler.classList.add(`${prefix}action--open`)
    }
  }

  submenus.forEach(el => {
    let submenuToggler = el.querySelector(`.${prefix}submenu-toggler`)

    submenuToggler.addEventListener('click', function () {
      toggleSubmenu(el, submenuToggler, 'open')
    })
  })
}

register('MobileNavigation', MobileNavigation)
